// sometimes redux is not enough :)

import {log} from "./log";
import {LiveChatUpdated} from "../events/ws";

export const Events = {
  LiveChatUpdated: "LiveChatUpdated",
} as const

export type EventKey = keyof typeof Events

export interface EventPayloads {
  LiveChatUpdated: LiveChatUpdated,
}

type EventHandler<K extends EventKey> = (data: EventPayloads[K]) => void

type ListenerMap = {
  [K in EventKey]: EventHandler<K>[]
}

// start with empty listeners
const listeners: Partial<ListenerMap> = {}

export const subscribe = <K extends EventKey>(
  event: K,
  callback: EventHandler<K>
): (() => void) => {
  // ensure array exists
  if (!listeners[event]) {
    listeners[event] = []
  }
  (listeners[event] as EventHandler<K>[]).push(callback)
  return () => {
    // @ts-ignore
    listeners[event] = (listeners[event] as EventHandler<K>[]).filter(
      (cb) => cb !== callback
    )
  }
}

export const publish = <K extends EventKey>(
  event: K,
  data: EventPayloads[K]
): void => {
  listeners[event]?.forEach((cb) => {
    (cb as EventHandler<K>)(data)
    log(`eventBus: sent ${event} event ${JSON.stringify(data)}`)
  })
}